import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";

var backfillOldData = function backfillOldData(_this) {
  var otherAgentInfo = _.cloneDeepGet(_this, "oppBusiData.oldBusiData.otherAgentInfo");
  if (!_.isEmpty(otherAgentInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherAgentInfo);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var otherAgentInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  if (!_.isEmpty(otherAgentInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherAgentInfo);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], otherAgentInfo);
  }
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;

  fields.ID_ADDR.VALID_TYPE = "valAX[16, 80]";

  fields.AGENT_BIRTHDAY.VALID_TYPE = "agesInit|birthday";
};

var update = function update(_this) {
  var module = _this.groupDatas[GROUP_ID][MODULE_ID][0];
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;

  var _loop = function _loop(key) {
    var funcArr = _.get(fields[key], "FIELD_FUNCTION", "").split("|");
    _.each(funcArr || [], function (func) {
      NODE[func] && NODE[func](_this, fields[key], fields, module);
    });
  };

  for (var key in fields) {
    _loop(key);
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);

    if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
      backfillOldData(_this);
    }
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
    update(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var oldOtherAgentInfo, otherAgentInfo, customerInfo, baseGroupId, baseModuleId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              oldOtherAgentInfo = _.get(_this.historyData, SAVE_PATH);
              otherAgentInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH]);
              customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO) || {};
              baseGroupId = _this.userType == "1" ? "ORG_INFO_PAGE" : "MANAGER_INFO_PAGE", baseModuleId = _this.userType == "1" ? "BASIC_MODULE" : "MANAGER_OTHER_INFO";

              _Object$assign(customerInfo, {
                CUST_NAME: otherAgentInfo.CUST_NAME
              });
              _this.$storage.setSession(_this.$definecfg.CUSTOMER_INFO, customerInfo);

              otherAgentInfo.ADDRESS = "";
              otherAgentInfo.BIRTHDAY = otherAgentInfo.AGENT_BIRTHDAY;
              otherAgentInfo.CELLPHONE_CONFIRM_FLAG = true;

              otherAgentInfo.CORP_ADDR = _this.groupDatas[baseGroupId][baseModuleId][0].FIELDS.CORP_ADDR.DEFAULT_VALUE;

              otherAgentInfo.EMAIL = "";
              otherAgentInfo.FAX = "";
              otherAgentInfo.IDENTITY_CLS = false;

              otherAgentInfo.ID_CODE = otherAgentInfo.AGENT_ID_CODE;
              otherAgentInfo.ID_EXP_DATE = otherAgentInfo.AGENT_ID_EXP_DATE;
              otherAgentInfo.ID_ISS_AGCY = "";
              otherAgentInfo.ID_TYPE = otherAgentInfo.AGENT_ID_TYPE;
              otherAgentInfo.ID_ZIP_CODE = _this.groupDatas[baseGroupId][baseModuleId][0].FIELDS.ID_ZIP_CODE.DEFAULT_VALUE;
              otherAgentInfo.LINKADDR_ORDER = "";
              otherAgentInfo.LINKTEL_ORDER = "";

              otherAgentInfo.OFFICE_TEL = "";

              otherAgentInfo.SEX = otherAgentInfo.AGENT_SEX;
              otherAgentInfo.TEL = "";
              otherAgentInfo.USER_FNAME = otherAgentInfo.AGENT_USER_FNAME;
              otherAgentInfo.USER_NAME = "";
              otherAgentInfo.WELL_TEL = "";
              otherAgentInfo.ZIP_CODE = "";
              otherAgentInfo.isPoliceCheck = "";
              otherAgentInfo.isReadCard = false;

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], otherAgentInfo);
              _.set(params, SAVE_PATH, _Object$assign(oldOtherAgentInfo, otherAgentInfo));

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),
  "CHECK_AGENT_ID_TYPE": function CHECK_AGENT_ID_TYPE(_this, field, fieldData) {
    fieldData["AGENT_ID_CODE"] && (fieldData["AGENT_ID_CODE"].VALID_TYPE = _this.$blMethod.getIdCodeValidType(field.DEFAULT_VALUE));
  },
  update: update
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizOther/bizOtherAgentInfoNode.js
// module id = 282
// module chunks = 2